import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeProvider';
import { getPracticeTestIconBg } from '../utils/themeUtils';

const InfoDialog = ({ isOpen, title, description, actions, testName = ''}) => {

  const { theme, currentTheme } = useContext(ThemeContext);

  if (!isOpen) return null;

  let bgColor;
  if (testName === 'test') {
    bgColor = getPracticeTestIconBg(theme, currentTheme); 
  } else {
    bgColor = currentTheme == 'light' 
    ? theme?.button?.primary?.background 
    : theme?.button?.secondary?.background;
  }

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 dark:bg-gray-800 dark:bg-opacity-75 flex justify-center items-center z-50">
      <div
        className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-lg w-11/12 md:w-1/3"
        style={{
          background: currentTheme === 'light' ? theme?.background?.light : theme?.background?.dark,
        }}
      >
        <h2 className="text-xl font-bold mb-4"
        style={{ color: currentTheme == 'light' ? theme?.text?.black : theme?.text?.secondary }}
        >
          {title}
        </h2>
        <div className="mb-4"
        style={{ color: currentTheme == 'light' ? theme?.text?.black : theme?.text?.secondary }}
        dangerouslySetInnerHTML={{ __html: description }}></div>

        <div className="flex justify-end space-x-4">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className={`px-4 py-2 rounded-lg transition-all duration-200 font-medium shadow-sm hover:shadow-md ${action.className}`}
              style={{ 
                background: bgColor,
                color: currentTheme == 'light'
                  ? theme?.button?.primary?.text || '#FFFFFF'
                  : theme?.button?.secondary?.text || '#FFFFFF',
                
              }}
            >
              {action.label} 
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfoDialog;
